import { XIcon } from 'lucide-react'

import { CLSize } from '~/components/component-library'
import { cn } from '~/utils/tailwind-utils'
import { sendTrackingData, TrackingProperties } from '~/utils/tracking'

export const ClearButton = ({
  onClick,
  eventName,
  eventProperties,
  className,
  hasError,
  inputSize = 'base',
  // Inside inputs the X is a mouse target only (keyboard clears via
  // Backspace); standalone uses pass 0 to stay tabbable.
  tabIndex = -1,
}: {
  onClick: () => void
  eventName?: string
  eventProperties?: TrackingProperties
  className?: string
  hasError?: boolean
  inputSize?: CLSize
  tabIndex?: number
}) => {
  const isSmall = inputSize === 'small'

  const handleClick = () => {
    // if tracking is enabled, send the tracking data
    if (eventName) sendTrackingData(eventName, eventProperties)

    onClick()
  }

  return (
    <button
      type="button"
      aria-label="Clear"
      tabIndex={tabIndex}
      onClick={handleClick}
      className={cn(
        'group flex aspect-square h-full items-center justify-center',
        className,
      )}
    >
      <div
        className={cn(
          'flex aspect-square items-center justify-center rounded-full text-primary group-hover:bg-gray-200 dark:group-hover:bg-gray-700',
          {
            'size-5': isSmall,
            'size-6': !isSmall,
            'text-error group-hover:bg-red-500/15 dark:text-red-400 dark:group-hover:bg-red-400/15':
              hasError,
          },
        )}
      >
        <XIcon className={cn({ 'size-3.5': isSmall, 'size-4': !isSmall })} />
      </div>
    </button>
  )
}
